export const leaderboard = {
  title: '排行榜',
  back: '返回',
  filters: {
    level: '技术等级',
    country: '国家/地区',
    city: '城市',
    category: '比赛类型',
    all: '全部',
  },
  categories: {
    mens_singles: '男单',
    womens_singles: '女单',
    mens_doubles: '男双',
    womens_doubles: '女双',
    mixed_doubles: '混双',
    all: '全部',
  },
  empty: {
    title: '这个等级还没有排名选手',
    subtitle: '成为第一个获得积分的人吧',
  },
  you: '你',
  points: '{{count}} 分',
  entryPoints: {
    label: '新手值',
    rule: '赢一个 game +10 分',
    columnHeader: '新手值',
  },
  rules: {
    title: '积分规则',
    intro: '仅 Acework 排名赛产生积分。两名选手必须确认并上传比赛照片以验证。',
    singleMatch: '1v1 排名赛胜利：+1 分',
    tournamentRound: '赛事轮次胜利：+10 × 倍数',
    semifinal: '半决赛胜利（打入决赛）：+100 × 倍数',
    runnerUp: '亚军：+150 × 倍数',
    champion: '冠军：+200 × 倍数',
    multiplierTitle: '赛事规模倍数',
    multiplier4: '4 人：0.5×',
    multiplier8: '8 人：1×',
    multiplier16: '16 人：2×',
    multiplier32: '32+ 人：4×',
    cumulative: '积分累积计算。失败不扣分。',
    privacyNote: '照片在比赛确认后 2 天自动删除。',
  },
};
